import { Link, Typography } from "@mui/material";

export type ConditionalLinkProps = {
    source: string;
};

const ConditionalLink = (props: ConditionalLinkProps) => {

    const isValidUrl = (text: string) => {
        try {
            new URL(text);
            return true;
        } catch (err) {
            return false;
        }
    };

    const getHostname = (url: string) => {
        try {
          const { hostname } = new URL(url);
          return hostname.replace(/^www\./, ''); // Entfernt "www." falls vorhanden
        } catch (err) {
          return url;
        }
    };
      

    return(
        <div>
            {isValidUrl(props.source) ? (
                <Link href={props.source} target="_blank" rel="noopener noreferrer">
                    {getHostname(props.source)}
                </Link>
            ) : (
                <Typography>{props.source}</Typography>
            )}
        </div>
    )
};

export default ConditionalLink;